import { render, staticRenderFns } from "./doucmentView.vue?vue&type=template&id=71a750d0&scoped=true&lang=html"
import script from "./doucmentView.vue?vue&type=script&lang=js"
export * from "./doucmentView.vue?vue&type=script&lang=js"
import style0 from "./doucmentView.vue?vue&type=style&index=0&id=71a750d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a750d0",
  null
  
)

export default component.exports